module.exports = __webpack_public_path__ + "img/13.4c736c7a.png";